<template>
  <div class="ml-5">
    <!-- <h3 class="ma-3">Podemos colocar um header aqui ou um breadcrumbs</h3> -->
    <Header />
    <router-view></router-view>
  </div>
</template>

<script>
import Header from '../header/Header.vue'
export default {
  name: 'Container',
  components: {
    Header,
  },
}
</script>
